import { useState } from "react";
import { MapPin, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { getOnce, detailMsg } from "@/lib/geo";
import { FormDialog } from "@/components/kids/kidsUi";

// Confirm what's shared and with whom, then read location once and post the check-in.
export function ShareConfirm({ hub, what, locOn, onClose, onDone }) {
  const [busy, setBusy] = useState(false);
  const share = async () => {
    setBusy(true);
    const pos = locOn ? await getOnce() : null;
    try {
      const { data } = await api.post(`/organizations/${hub.id}/checkins`, { status: what.status, place_id: what.place_id || null, ...(pos || {}) });
      toast.success(data.text);
      if (locOn && !data.location_shared) toast.warning("Location wasn't shared.", { id: "loc-not-shared" });
      onDone?.(data); onClose();
    } catch (e) { toast.error(detailMsg(e, "Couldn't post that")); setBusy(false); }
  };
  return (
    <FormDialog open onClose={onClose} title={what.title} testid="share-confirm">
      <div className="space-y-3 text-sm text-q-muted" data-testid="share-confirm-text">
        <p className="flex gap-2"><ShieldCheck className="h-4 w-4 shrink-0 text-emerald-400" /> Posts “{what.title}” with the time to your family's Who's where.</p>
        {locOn ? <p className="flex gap-2"><MapPin className="h-4 w-4 shrink-0" /> Your location is read once, now. Parents and you see it on a map; relatives see only the place name. It's deleted after 24 hours.</p>
          : <p className="flex gap-2" data-testid="share-confirm-noloc"><MapPin className="h-4 w-4 shrink-0" /> Location is off for you, so none is shared.</p>}
        <button className="q-btn q-btn-primary min-h-[48px] w-full" disabled={busy} onClick={share} data-testid="share-confirm-btn">{busy ? "Sharing…" : "Share"}</button>
      </div>
    </FormDialog>
  );
}

export function SafeButton({ hub, locOn, onDone, testid = "im-safe-btn" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button className="q-btn min-h-[48px] bg-emerald-500 font-bold text-[#052e16] hover:bg-emerald-400" onClick={() => setOpen(true)} data-testid={testid}><ShieldCheck className="h-5 w-5" /> I'm safe</button>
      {open && <ShareConfirm hub={hub} what={{ status: "safe", title: "I'm safe" }} locOn={locOn} onClose={() => setOpen(false)} onDone={onDone} />}
    </>
  );
}
